import { render, staticRenderFns } from "./comprasMias.vue?vue&type=template&id=f17f57bc&scoped=true&"
import script from "./comprasMias.vue?vue&type=script&lang=js&"
export * from "./comprasMias.vue?vue&type=script&lang=js&"
import style0 from "./comprasMias.vue?vue&type=style&index=0&id=f17f57bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f17f57bc",
  null
  
)

export default component.exports